import AsyncStorage from '@react-native-async-storage/async-storage';

const CHAVE_POPUP_DATA_NAO_EXIBIR = 'popup_central_funcionario_data_nao_exibir';

// Controla, apenas em memória, se o popup já foi verificado nesta sessão do app,
// para não repetir a consulta e a possível exibição a cada tela montada.
let popupVerificadoNaSessaoAtual = false;

export const marcarPopupVerificadoNaSessaoAtual = (): void => {
  popupVerificadoNaSessaoAtual = true;
};

export const popupJaVerificadoNaSessaoAtual = (): boolean => {
  return popupVerificadoNaSessaoAtual;
};

export const resetarPopupVerificadoNaSessaoAtual = (): void => {
  popupVerificadoNaSessaoAtual = false;
};

export const salvarDataNaoExibirPopupAsync = async (
  dataPublicacao: string
): Promise<void> => {
  try {
    await AsyncStorage.setItem(CHAVE_POPUP_DATA_NAO_EXIBIR, dataPublicacao);
  } catch (erro) {
    console.error('Erro ao salvar data de não exibir popup:', erro);
  }
};

export const deveExibirPopupAsync = async (
  dataPublicacao: string
): Promise<boolean> => {
  try {
    const dataArmazenada = await obterDataNaoExibirPopupAsync();

    if (!dataArmazenada) {
      return true;
    }

    const dataArmazenadaObj = new Date(dataArmazenada);
    const dataPublicacaoObj = new Date(dataPublicacao);

    return dataPublicacaoObj > dataArmazenadaObj;
  } catch (erro) {
    console.error('Erro ao verificar se deve exibir popup:', erro);
    return true;
  }
};

const obterDataNaoExibirPopupAsync = async (): Promise<string | null> => {
  try {
    return await AsyncStorage.getItem(CHAVE_POPUP_DATA_NAO_EXIBIR);
  } catch (erro) {
    console.error('Erro ao obter data de não exibir popup:', erro);
    return null;
  }
};
